<template>
    <v-news-card v-if="type===1"  :title="title" :class="cls" :style="stys" :list="list" :more-url="setting.moreUrl"></v-news-card>
    <v-image-card v-else-if="type===2" :title="title" :height="setting.height||200" :class="cls" :style="stys" :list="list" :more-url="setting.moreUrl"></v-image-card>
    <v-image-news-card v-else-if="type===3" :title="title" :height="setting.height||200" :class="cls" :style="stys" :img-list="imgList"  :list="list" :more-url="setting.moreUrl"></v-image-news-card>
    <v-news-scroll-card v-else-if="type===4" :title="title"  :class="cls"  :list="list" :first="first" :more-url="setting.moreUrl"></v-news-scroll-card>
    <v-image-other-card v-else-if="type===5" :title="title"  :class="cls"  :list="list" :first="first" :more-url="setting.moreUrl"></v-image-other-card>
    <v-card v-else-if="type===0" :title="title" :class="cls" :style="stys">
        <template slot="extra" v-if="setting.moreUrl">
            <a :href="setting.moreUrl" style="color: #bec7ca">MORE+</a>
        </template>
        <div class="news-card" v-html="content"></div>
    </v-card>
</template>
<style lang="less" scoped>
    .news-card{
        padding: 8px;
    }
</style>
<script>
    import moment from 'moment'
    import service from '../../common/service'
    import VNewsCard from "../../../components/NewsCard";
    import VCard from "../../../components/Card";
    import VImageCard from "../../../components/ImageCard";
    import VImageNewsCard from "../../../components/ImageNewsCard";
    import VNewsScrollCard from "../../../components/NewsScrollCard";
    import VImageOtherCard from "../../../components/ImageOtherCard";

    const contentService = new service({baseUrl:'/web/article'});

    const memberService = new service({baseUrl:'/api/member'});

    export default {
        name:'v-element',
        data() {
            return {
                content:'',
                data:{},
                list:[],
                imgList:[],
                first:"",
                typeIndex:1,
                index:0,
            }
        },
        computed:{
            count(){
                return this.setting.dataCount||5;
            },
            type(){
                return this.setting.type;
            },
            title(){
                return this.setting.title;
            },
            cls(){
                 return this.setting.classname;
            },
            stys(){
                if(this.setting.height){
                    return {minHeight:this.setting.height + 'px'};
                }
                return {};
            },
            dataId(){
                if(this.setting){
                    return this.setting.dataId;
                }
                return '';
            }
        },
        props:['setting'],
        components: {VImageOtherCard, VNewsScrollCard, VImageNewsCard, VImageCard, VCard, VNewsCard},
        watch:{
            'dataId'(){
                this.fetchContent();
            }
        },
        mounted(){
            if(this.type===0){
                this.fetchContent();
            }else {
                this.fetchList();
            }
        },
        methods:{
            initData(list){
                const self = this;
                let key = Object.keys(list)[self.typeIndex];
                self.list = [];
                if(self.index < list[key].length){
                }else if(self.typeIndex===(Object.keys(list).length-1)){
                    self.index = 0;
                    self.typeIndex = 1;
                }else {
                    self.index = 0;
                    self.typeIndex += 1;
                }
                key = Object.keys(list)[self.typeIndex];
                for (let i = 0;i < 8;i++){
                    if(self.index < list[key].length){
                        self.list.push(list[key][self.index])
                        self.index += 1;
                    }
                }
            },
            fetchContent(){
                let self = this;
                if(this.type===0&&this.dataId){
                    contentService.get(`${this.dataId}/content`).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            self.content = json.data;
                        }
                    })
                }
            },
            fetchList(){
                let self = this;
                if(this.type===1&&this.dataId){
                    contentService.page({'s_IN_o$catalogId':this.dataId,size:this.count,'o_1_o$issueTime':'desc','o_2_o$id':'desc'}).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let ls = [];
                            (json.data.data||[]).forEach((o,i)=>{
                                let m = {
                                    link:`/channel/${o.channelId||0}/${o.id}`,
                                    title:o.name,summary:o.summary,time:moment(o.issueTime).format('YYYY-MM-DD')
                                };
                                ls.push(m);
                            })
                            self.list = ls;
                        }
                    })
                }
                if(this.type===2&&this.dataId){
                    contentService.postForm('d',{'catalogId':this.dataId,size:this.count}).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let ls = [];
                            (json.data||[]).forEach((o,i)=>{
                                let m = {
                                    src:o.link,
                                    link:`/channel/${o.channelId||0}/${o.id}`
                                };
                                ls.push(m);
                            })
                            self.list = ls;
                        }
                    })
                }
                if(this.type===3&&this.dataId){
                    contentService.postForm('images',{'catalogId':this.dataId,size:this.count}).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let ls = [];
                            (json.data||[]).forEach((o,i)=>{
                                let m = {
                                    src:o.link,
                                    link:`/channel/${o.channelId||0}/${o.id}`
                                };
                                ls.push(m);
                            })
                            self.imgList = ls;
                        }
                    })
                    contentService.page({'s_IN_o$catalogId':this.dataId,size:this.count,'o_1_o$issueTime':'desc','o_2_o$id':'desc'}).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let ls = [];
                            (json.data.data||[]).forEach((o,i)=>{
                                let m = {
                                    link:`/channel/${o.channelId||0}/${o.id}`,
                                    title:o.name,summary:o.summary,time:moment(o.issueTime).format('YYYY-MM-DD')
                                };
                                ls.push(m);
                            })
                            self.list = ls;
                        }
                    })
                }
                if(this.type===4){
                    memberService.get('findAll',null).then((res)=>{
                        let json = res.data;
                        if(json.success){
                            let ls = [];
                            (Object.values(json.data)||[]).forEach((o,i)=>{
                                if(i!==0){
                                    ls.push(o);
                                }else {
                                    this.first = o[0];
                                }
                            });
                            self.list = ls;
                        }
                    })
                }
            }
        }
    }
</script>
